import { axiosClient } from "../../../config/axios";

export const signUpApi = async (payload) => {
	const res = await axiosClient.post("/user/new", payload);
	return res;
};

export const changeLangApi = async (lang) => {
	const res = await axiosClient.post("/lang/change", {
		lang,
	});
	return res;
};

export const loginSuccesApi = async () => {
	const res = await axiosClient.get("/login/success");
	return res;
};

export const loadChatsApi = async (skip) => {
	const res = await axiosClient.get("/messages/load/" + skip);
	return res;
};

export const loginUserApi = async (payload) => {
	const res = await axiosClient.post("/user/login", payload);
	return res;
};

export const logoutApi = async () => {
	const res = await axiosClient("/logout");
	return res;
};

export const postMessageApi = async (newMessage) => {
	const res = await axiosClient.post("/message/new", newMessage);

	return res;
};
export const postFeedbackApi = async (payload) => {
	try {
		const res = await axiosClient.post("/feedback/new", payload);
		return res;
	} catch (error) {
		return error.response;
	}
};
export const postPredictionApi = async (payload) => {
	try {
		const res = await axiosClient.post("/prediction/new", payload);
		console.log("response res", res);
		return res;
	} catch (error) {
		console.log("response err", error.response);
		return error.response;
	}
};

export const getFeedbackApi = async (payload) => {
	const res = await axiosClient.get(`/feedback?page=${payload}&limit=10`);
	return res;
};

export const postImageApi = async (payload) => {
	const res = await axiosClient.post("/upload/file", payload);
	return res;
};

export const toggleChatLoveApi = async (payload) => {
	const res = await axiosClient.get(`/message/${payload}/love`);
	return res;
};

export const lovedChatsApi = async () => {
	const res = await axiosClient.get(`/messages/loved`);
	return res;
};

export const submitFormApi = async (payload) => {
	const res = await axiosClient.post(`/police/verification/form`, payload);
	return res;
};
